import { useQuery } from '@tanstack/react-query';

import { useHasPermission } from '../hooks/useHasPermission';
import { AuthorityService } from '../services/authority.service';
import { queryClient } from '../components/queryClient';

export const useAllAuthoritiesQuery = () => {
  const hasPermission = useHasPermission('authorities:read:list');
  const queryKey = ['allAuthorities'];

  const queryFn = () => AuthorityService.getAllAuthorities();

  return useQuery({
    queryKey,
    queryFn,
    defaultData: [],
    enabled: hasPermission,
  });
};

export const useAuthorityQuery = (authorityUuid: string) => {
  const hasPermission = useHasPermission('authorities:read');

  return useQuery({
    queryKey: ['authority', authorityUuid, 'details'],
    queryFn: () => AuthorityService.getAuthority(authorityUuid),
    enabled: hasPermission && !!authorityUuid,
  });
};

export const refreshAuthority = (authorityUuid: string) => {
  queryClient.invalidateQueries({ queryKey: ['authority', authorityUuid, 'details'] });
};

export const forceRefreshAuthorities = () => {
  queryClient.invalidateQueries({ queryKey: ['allAuthorities'] });
};

export const useAuthorityBoundaryQuery = (authorityUuid: string) => {
  const hasPermission = useHasPermission('authorities:read:boundary');

  return useQuery({
    queryKey: ['authority', authorityUuid, 'boundary'],
    queryFn: () => AuthorityService.getAuthorityBoundary(authorityUuid),
    defaultData: null,
    enabled: hasPermission && !!authorityUuid,
  });
};

export const refreshAuthorityBoundary = (authorityUuid: string) => {
  queryClient.invalidateQueries({ queryKey: ['authority', authorityUuid, 'boundary'] });
};
